import { customAxios,IDUSUARIO,GENERIC_URL } from '../constants';

export default function(cliente){

    const config = {
        headers:{
            idUsuario: IDUSUARIO,
        }
    };

    return customAxios.get(`${GENERIC_URL}/cliente/cliente/${cliente}/contactos`,config);    
}


// WEBPACK FOOTER //
// ./src/utils/getContactoCliente.js